'use strict';

var AdvancedHepSystemConfigButtonsUtilsService = function AdvancedHepSystemConfigButtonsUtilsService() {
  function reloadGrid(gridPanel) {
    var loadedData = gridPanel.jqxGridSettings.source.loadedData;
    gridPanel.updateData(loadedData);
  }
  function refreshGrid(gridPanel) {
    gridPanel.clearCache();
    gridPanel.clearSelection();
    gridPanel.jqxGridSettings.jqxGrid('updatebounddata', 'data');
  }
  return {
    reloadGrid: reloadGrid,
    refreshGrid: refreshGrid
  };
};
AdvancedHepSystemConfigButtonsUtilsService.$inject = [];
module.exports = AdvancedHepSystemConfigButtonsUtilsService;